import * as type from "./types";

export function fetchSegmapList() {
  return {
    type: type.FETCH_SEGMAP_LIST,
  };
}

export function storeFetchedSegmapList(segmapList) {
  return {
    type: type.STORE_FETCHED_SEGMAP_LIST,
    payload: segmapList,
  };
}

export function storeFetchedCompanyList(companyList) {
  return {
    type: type.STORE_FETCHED_COMPANY_LIST,
    payload: companyList,
  };
}

export function fetchCostCategory() {
  return {
    type: type.FETCH_COST_CATEGORY,
  };
}

export function storeFetchedCostCategory(costCategoryList) {
  return {
    type: type.STORE_FETCHED_COST_CATEGORY,
    payload: costCategoryList,
  };
}

export function fetchCostCenter() {
  return {
    type: type.FETCH_COST_CENTER,
  };
}

export function storeFetchedCostCenter(costCenterList) {
  return {
    type: type.STORE_FETCHED_COST_CENTER,
    payload: costCenterList,
  };
}

export function setAlertModalState(payload) {
  return {
    type: type.SET_ALERT_MODAL_STATE,
    payload,
  };
}
